/**
 * Tiny in-memory cache with TTL (e.g. OrdersList shipStation responses).
 * Separate from `shipmentCache` (localStorage / receiving flow).
 */
export interface MemoryTtlCacheState<T> {
  data: T | null;
  timestamp: number;
}

export function createMemoryTtlCache<T>(ttlMs: number): {
  readonly ttlMs: number;
  isValid: () => boolean;
  get: () => T | null;
  set: (value: T) => void;
  clear: () => void;
} {
  let state: MemoryTtlCacheState<T> = { data: null, timestamp: 0 };

  return {
    ttlMs,
    isValid: (): boolean =>
      state.data !== null && state.timestamp > 0 && Date.now() - state.timestamp < ttlMs,
    get: (): T | null => state.data,
    set: (value: T): void => {
      state = { data: value, timestamp: Date.now() };
    },
    clear: (): void => {
      state = { data: null, timestamp: 0 };
    },
  };
}
